<template>
  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  >
    <!-- <component :is="layout"> -->
      <router-view />
      <!-- <ControlMenu /> -->
    <!-- </component> -->

    <scroll-to-top v-if="enableScrollToTop" />
  </div>
</template>

<script>
import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue'
import ControlMenu from '@/components/ControlMenu.vue'
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'

export default {
  components: {
    useAppConfig,
    ControlMenu,
    ScrollToTop,
  },
  data() {
    return {
      observer: null
    }
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
    pantallaActual() {
      console.log(this.$route.name);
      return this.$route.name;
    }
  },
  methods: {
    crearObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new MutationObserver(() => {
        const backdrop = document.querySelector('.b-sidebar-backdrop');
        const inputs = this.$root.$el.querySelectorAll('.custom-radio');
        const checkinputs = this.$root.$el.querySelectorAll('.custom-checkbox');
        console.log(inputs);
        console.log(checkinputs);
        if (backdrop && getComputedStyle(backdrop).display === 'none') {
          // Agregar clase active a cada input
          inputs.forEach(input => {
            input.classList.remove('active');
          });
          checkinputs.forEach(input => {
            input.classList.remove('active');
          });
        } else {
          // Remover clase active de cada input
          inputs.forEach(input => {
            input.classList.add('active');
          });
          checkinputs.forEach(input => {
            input.classList.add('active');
          });
        }
      });

      this.observer.observe(document.querySelector('.b-sidebar-backdrop'), {
        attributes: true,
        attributeFilter: ['style'],
      });
    }
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  watch: {
    pantallaActual() {
      this.crearObserver();
    }
  },
  mounted() {
    this.crearObserver();
  },
  beforeRouteUpdate(to, from, next) {
    this.observer.disconnect();
    next();
  },
  updated() {
    this.crearObserver();
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()
    const { enableScrollToTop } = $themeConfig.layout
    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
      enableScrollToTop,
    }
  },
}
</script>
<style>
table{
  width: 100% !important;
  border: 1px solid #DCDFE6 !important;
}
td{
      padding-left: 10px;
      padding-right: 10px;
    }
table tr{
  border: 1px solid #DCDFE6 !important;
}
thead{
  background-color: #5E8F23 !important;
  text-align:center;
  color:#ffffff;
}
[dir] .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th, [dir] .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {
  background-color: #5E8F23 !important;
}
[dir] button.bg-primary:focus {
    background-color: #5E8F23 !important;
}
.pbbuton{
  padding-bottom:200px;
}
.offline{
  text-align: center;
  background-color: red;
  color: #ffffff;
  font-size: 12px;
}
.footer__navigation {
  display:flex;

}
</style>
